export default __webpack_public_path__ + "static/media/apple-store.45b9f9de.svg";